import { render, staticRenderFns } from "./DragBox.vue?vue&type=template&id=5a598a8c&scoped=true&"
import script from "./DragBox.vue?vue&type=script&lang=js&"
export * from "./DragBox.vue?vue&type=script&lang=js&"
import style0 from "./DragBox.vue?vue&type=style&index=0&id=5a598a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a598a8c",
  null
  
)

export default component.exports